import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisModalRef, IrisModalService, IrisModalSize } from '@sondermind/iris/modal';

@Component({
  selector: 'sondermind-alert-modal',
  templateUrl: './alert-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    IrisButtonModule,
  ]
})
export class AlertModalComponent {
  readonly size = input<IrisModalSize>(IrisModalSize.MD);
  readonly showHeader = input<boolean>(true);

  constructor(
    public irisModalRef: IrisModalRef<AlertModalComponent, any, boolean>,
    private irisModalService: IrisModalService
  ) { }

  open(title: string, body: string, color = 'primary'): void {
    this.irisModalService.open(AlertModalComponent, {
      data: {
        titleText: title, bodyText: body, isOpened: true, color
      },
      size: this.size(),
      showHeader: this.showHeader()
    }).afterClosed$();
  }
}
